import React, { Component } from 'react';
import PlatformSidebar from './PlatformSidebar';
import Onboarding from './Onboarding.js';
import AddFunds from './AddFunds.js';
import ImportFromPassword from './ImportFromPassword';
import { CgProfile } from "react-icons/cg";
import { GrEmoji } from "react-icons/gr";
import { IoPeopleOutline } from "react-icons/io5"
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";

class CreatorDashboardSidebar extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div>
          <div className="w-24 sm:w-60 z-20 fixed bg-custom-black top-16 bottom-0 border-r border-zinc-800">
            <div className="font-bold text-white text-xs sm:text-sm ml-2 sm:ml-10 py-2">
              DASHBOARD
            </div>
            <div className="w-full flex flex-col items-center">
              <div
                className={
                  this.props.selectedTab === "profile"
                    ?
                  "flex items-center text-white bg-zinc-700 font-medium text-base px-10 py-2 rounded-sm cursor-pointer w-[98%]"
                    :
                  "flex items-center text-gray-400 font-medium text-base px-10 py-2 cursor-pointer rounded-sm hover:bg-zinc-800 w-[98%]"
                }
                onClick={() => this.props.selectTab("profile")}
              >
                <div className="mr-2">
                  <CgProfile />
                </div>
                <div className="hidden md:flex items-center justify-center">
                  Profile
                </div>
              </div>
              <div
                className={
                  this.props.selectedTab === "reactions"
                    ?
                  "flex items-center text-white bg-zinc-700 font-medium text-base px-10 py-2 rounded-sm cursor-pointer w-[98%]"
                    :
                  "flex items-center text-gray-400 font-medium text-base px-10 py-2 cursor-pointer rounded-sm hover:bg-zinc-800 w-[98%]"
                }
                onClick={() => this.props.selectTab("reactions")}
              >
                <div className="mr-2">
                  <GrEmoji />
                </div>
                <div className="hidden md:flex items-center justify-center">
                  Reactions
                </div>
              </div>
              <div
                className={
                  this.props.selectedTab === "subscribers"
                    ?
                  "flex items-center text-white bg-zinc-700 font-medium text-base px-10 py-2 rounded-sm cursor-pointer w-[98%]"
                    :
                  "flex items-center text-gray-400 font-medium text-base px-10 py-2 cursor-pointer rounded-sm hover:bg-zinc-800 w-[98%]"
                }
                onClick={() => this.props.selectTab("subscribers")}
              >
                <div className="mr-2">
                  <IoPeopleOutline />
                </div>
                <div className="hidden md:flex items-center justify-center">
                  Subscribers
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreatorDashboardSidebar;
